var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _path0, _path1, _path10, _path11, _ellipse, _ellipse2, _path12, _path13, _path14, _path15, _rect3, _path16, _path17, _path18, _rect4, _rect5, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGolem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "g-stone",
    cx: "40%",
    cy: "35%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6a6055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#3a3530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a1815"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g-stone2",
    cx: "45%",
    cy: "40%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5a5248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e1c18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g-eye",
    cx: "40%",
    cy: "35%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff8c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#ffaa00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#882200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g-crack-glow",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff8800",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#cc3300",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g-glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "g-crack"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 60 125 C 55 105 58 80 72 65 L 168 65 C 182 80 185 105 180 125 L 178 185 C 176 200 165 212 145 215 L 95 215 C 75 212 64 200 62 185 Z",
    fill: "url(#g-stone)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 70 90 L 170 90 L 172 130 L 68 130 Z",
    fill: "#2e2b26",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 65 135 L 175 135 L 177 175 L 63 175 Z",
    fill: "#28251f",
    opacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 68 C 105 85 98 100 103 118 C 107 130 100 145 105 165 C 108 180 103 200 100 215",
    fill: "none",
    stroke: "url(#g-crack-glow)",
    strokeWidth: 2.5,
    filter: "url(#g-crack)",
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 140 68 C 143 88 148 108 143 125 C 138 140 142 162 145 185 C 147 198 145 208 143 215",
    fill: "none",
    stroke: "#ff7700",
    strokeWidth: 1.8,
    filter: "url(#g-crack)",
    opacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 145 C 90 148 108 143 125 146 C 142 149 158 145 172 148",
    fill: "none",
    stroke: "#cc5500",
    strokeWidth: 1.5,
    filter: "url(#g-crack)",
    opacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 68 110 C 82 112 95 108 110 112",
    fill: "none",
    stroke: "#dd6600",
    strokeWidth: 1.2,
    filter: "url(#g-crack)",
    opacity: 0.55
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 152 108 C 158 105 165 110 172 107",
    fill: "none",
    stroke: "#cc5500",
    strokeWidth: 1.2,
    filter: "url(#g-crack)",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 68 C 120 100 120 140 120 215",
    fill: "none",
    stroke: "#ff9900",
    strokeWidth: 1,
    opacity: 0.3,
    filter: "url(#g-glow)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 72,
    width: 35,
    height: 30,
    rx: 5,
    fill: "url(#g-stone2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 72,
    width: 35,
    height: 30,
    rx: 5,
    fill: "url(#g-stone2)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 78 C 55 84 52 90 57 96",
    fill: "none",
    stroke: "#ff7700",
    strokeWidth: 1.5,
    filter: "url(#g-crack)",
    opacity: 0.7
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 175 80 C 178 86 176 92 180 98",
    fill: "none",
    stroke: "#ff7700",
    strokeWidth: 1.5,
    filter: "url(#g-crack)",
    opacity: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 42 82 C 28 90 18 110 15 135 C 12 155 20 175 32 185 C 28 165 28 140 36 118 C 40 107 45 96 50 88 Z",
    fill: "url(#g-stone)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 198 82 C 212 90 222 110 225 135 C 228 155 220 175 208 185 C 212 165 212 140 204 118 C 200 107 195 96 190 88 Z",
    fill: "url(#g-stone)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 188,
    rx: 22,
    ry: 18,
    fill: "url(#g-stone2)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212,
    cy: 188,
    rx: 22,
    ry: 18,
    fill: "url(#g-stone2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 12 183 C 16 178 22 175 28 176 C 34 175 40 178 44 183",
    fill: "none",
    stroke: "#5a5248",
    strokeWidth: 2,
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 196 183 C 200 178 206 175 212 176 C 218 175 224 178 228 183",
    fill: "none",
    stroke: "#5a5248",
    strokeWidth: 2,
    opacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 18 185 C 22 190 26 188 30 193",
    fill: "none",
    stroke: "#ff8800",
    strokeWidth: 1.2,
    filter: "url(#g-crack)",
    opacity: 0.65
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 205 185 C 209 190 213 188 217 193",
    fill: "none",
    stroke: "#ff8800",
    strokeWidth: 1.2,
    filter: "url(#g-crack)",
    opacity: 0.65
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 48,
    width: 40,
    height: 22,
    rx: 4,
    fill: "url(#g-stone2)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 108 52 C 112 58 108 64 112 70",
    fill: "none",
    stroke: "#dd6600",
    strokeWidth: 1.2,
    filter: "url(#g-crack)",
    opacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 72 18 C 74 8 85 2 120 2 C 155 2 166 8 168 18 L 170 52 C 168 62 155 68 120 68 C 85 68 72 62 70 52 Z",
    fill: "url(#g-stone)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 78 22 L 162 22 L 164 48 L 76 48 Z",
    fill: "#302d28",
    opacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 28,
    width: 96,
    height: 14,
    rx: 3,
    fill: "#2a2724"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 28,
    width: 96,
    height: 14,
    rx: 3,
    fill: "#4a4540",
    opacity: 0.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98,
    cy: 42,
    rx: 16,
    ry: 13,
    fill: "#110800"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142,
    cy: 42,
    rx: 16,
    ry: 13,
    fill: "#110800"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98,
    cy: 42,
    rx: 16,
    ry: 13,
    fill: "url(#g-eye)",
    filter: "url(#g-glow)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98,
    cy: 42,
    rx: 9,
    ry: 7,
    fill: "#ffcc44"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98,
    cy: 42,
    rx: 4,
    ry: 3,
    fill: "#ff4400"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95,
    cy: 40,
    rx: 2,
    ry: 1.5,
    fill: "#fff8cc",
    opacity: 0.9
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142,
    cy: 42,
    rx: 16,
    ry: 13,
    fill: "url(#g-eye)",
    filter: "url(#g-glow)"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142,
    cy: 42,
    rx: 9,
    ry: 7,
    fill: "#ffcc44"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142,
    cy: 42,
    rx: 4,
    ry: 3,
    fill: "#ff4400"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139,
    cy: 40,
    rx: 2,
    ry: 1.5,
    fill: "#fff8cc",
    opacity: 0.9
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 2 C 122 14 118 28 122 42",
    fill: "none",
    stroke: "#ff8800",
    strokeWidth: 1.5,
    filter: "url(#g-crack)",
    opacity: 0.6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 88 4 C 86 14 90 24 86 34",
    fill: "none",
    stroke: "#cc6600",
    strokeWidth: 1,
    filter: "url(#g-crack)",
    opacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 4 C 152 14 148 24 152 34",
    fill: "none",
    stroke: "#cc6600",
    strokeWidth: 1,
    filter: "url(#g-crack)",
    opacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 92 58 C 100 62 110 64 120 64 C 130 64 140 62 148 58",
    fill: "none",
    stroke: "#220a00",
    strokeWidth: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 95 58 C 104 61 112 63 120 63 C 128 63 136 61 145 58",
    fill: "none",
    stroke: "#ff6600",
    strokeWidth: 1.5,
    filter: "url(#g-crack)",
    opacity: 0.7
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 75 Q 120 70 165 75",
    fill: "none",
    stroke: "#8a7a65",
    strokeWidth: 1,
    opacity: 0.25
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 68 105 Q 120 100 172 105",
    fill: "none",
    stroke: "#7a6a58",
    strokeWidth: 0.8,
    opacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 82 6 Q 120 0 158 6",
    fill: "none",
    stroke: "#cc6618",
    strokeWidth: 2,
    opacity: 0.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolem);
export default __webpack_public_path__ + "static/media/golem.bfb2e7ce31d76b9ffa442c2d904828f6.svg";
export { ForwardRef as ReactComponent };